import { TABLA_CAMIONES_EN_TRANSITO, TABLA_CAMIONES_EN_TRANSITO_TOTAL } from '../../../../../config/tables'
import { COLUMNS_CAMIONES_EN_TRANSITO, COLUMNS_CAMIONES_EN_TRANSITO_TOTAL } from './constantesCamionesEnTransito'
import CpaPresunta from '../../../../../models/camiones/cpa_presunta'
import moment from 'moment'

export function parseData (data) {
  const parsedData = []
  if (data.length > 0) {
    data.map((entry) => {
      moment.locale('ar-AR')
      const fecha = moment(entry.fechaCupo).format('DD-MM-YYYY')
      return parsedData.push({ ...entry, data: entry, fecha: fecha })
    })
  }
  return parsedData
}

export function cargarTablaConsumidosARCA (d, filtroInicial) {
  return (dispatch) => {
    const data = parseData(d)
    const customToolbar = null
    const textRowCount = 'Cantidad de camiones: '
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        columns: COLUMNS_CAMIONES_EN_TRANSITO,
        data: data,
        title: 'Cartas de porte consumidas en ARCA - Camiones en viaje',
        isLoading: false,
        fixed2Decimales: false,
        responsive: 'vertical',
        extraOptions: {
          customToolbar,
          pagination: false,
          tableBodyMaxHeight: '399px',
          download: false,
          filtroInicial,
          showRowCount: true,
          textRowCount
        }
      },
      id: TABLA_CAMIONES_EN_TRANSITO
    })
  }
}

export function actualizarCamionesEnTransito (filtroInicial) {
  return (dispatch) => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_EN_TRANSITO
    })
    CpaPresunta.getCpaPresunta()
      .then((d) => {
        const fechaActualizacion = moment(new Date()).format('DD-MM-YYYY HH:mm')
        return dispatch(cargarTablaConsumidosARCA(d, filtroInicial, fechaActualizacion))
      })
  }
}

export function actualizarDatosCamionesEnTransito (filtroInicial) {
  return (dispatch, getState) => {
    const state = getState()
    const data = state.dashboard.consumidosARCA || null
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: true
      },
      id: TABLA_CAMIONES_EN_TRANSITO
    })

    if (data) {
      dispatch(cargarTablaConsumidosARCA(data, filtroInicial))
    } else {
      CpaPresunta.getCpaPresunta()
        .then((d) => {
          return dispatch(cargarTablaConsumidosARCA(d, filtroInicial))
        })
    }
  }
}

export function getDataConsumidosEnViaje () {
  return (dispatch) => {
    CpaPresunta.getCpaPresunta()
      .then((data) => {
        const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
        return dispatch({ type: 'RECEIVE_CONSUMIDOS_ARCA', data, fecha })
      })
  }
}

export function actualizarDatosParaMuiTable () {
  return dispatch => {
    dispatch({
      type: 'UPDATE_MUITABLE',
      newState: {
        isLoading: false
      },
      id: TABLA_CAMIONES_EN_TRANSITO_TOTAL
    })
    CpaPresunta.getCpaPresuntaTotalizadora()
      .then((d) => {
        const fecha = moment(new Date()).format('DD-MM-YYYY HH:mm')
        dispatch({ type: 'ACTUALIZACION_CONSUMIDOS_ARCA', fecha })
        const data = parseData(d)
        const customToolbar = null
        dispatch({
          type: 'UPDATE_MUITABLE',
          newState: {
            columns: COLUMNS_CAMIONES_EN_TRANSITO_TOTAL,
            data: data,
            title: 'Consumidas en ARCA (En viaje)',
            isLoading: false,
            fixed2Decimales: false,
            extraOptions: {
              customToolbar,
              print: false,
              pagination: false,
              download: false,
              filter: false,
              search: false,
              viewColumns: false
            }
          },
          id: TABLA_CAMIONES_EN_TRANSITO_TOTAL
        })
      })
  }
}
